import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Loads draft listings and prefill data from location state or previous page
 * Populates form fields accordingly
 */
export const useDraftLoading = (
  draftListing: any,
  setValue: any,
  clearErrors: any,
  setLocationInput: any,
  setStep: any,
  setExistingDraftId: any,
  setPrefilledImages: any,
  setListingType?: any
) => {
  const location = useLocation();

  // Load draft listing
  useEffect(() => {
    if (draftListing) {
      // Set listing type to 'single' for draft listings
      if (setListingType) {
        setListingType('single');
      }

      if (draftListing.title) setValue('title', draftListing.title);
      if (draftListing.type) setValue('type', draftListing.type);
      if (draftListing.price) setValue('price', draftListing.price);
      if (draftListing.location) {
        setValue('location', draftListing.location);
        setLocationInput(draftListing.location);
      }
      if (draftListing.virtualTourUrl) setValue('virtualTourUrl', draftListing.virtualTourUrl);
      if (draftListing.bedrooms !== undefined) setValue('bedrooms', draftListing.bedrooms);
      if (draftListing.size) setValue('size', draftListing.size);
      if (draftListing.bathrooms !== undefined) setValue('bathrooms', draftListing.bathrooms);
      if (draftListing.description) setValue('description', draftListing.description);
      if (draftListing.amenities) setValue('amenities', draftListing.amenities);
      if (draftListing.availableFrom) {
        const availableDate =
          draftListing.availableFrom instanceof Date
            ? draftListing.availableFrom
            : (draftListing.availableFrom as any).toDate?.() || new Date();
        setValue('availableFrom', availableDate);
      }
      if (draftListing.berRating) setValue('berRating', draftListing.berRating);
      if (draftListing.videoUrl) setValue('videoUrl', draftListing.videoUrl);

      setExistingDraftId(draftListing.id as number);
      setStep(3);
    }
  }, [draftListing, setValue, setLocationInput, setStep, setExistingDraftId, setListingType]);

  // Load prefill data
  useEffect(() => {
    const prefillData = location.state?.prefillData;
    if (prefillData) {
      if (prefillData.title) setValue('title', prefillData.title);
      if (prefillData.type) setValue('type', prefillData.type);
      if (prefillData.price) setValue('price', prefillData.price);

      if (prefillData.address || prefillData.location) {
        const loc = prefillData.address || prefillData.location;
        setValue('location', loc);
        setLocationInput(loc);
      }

      if (prefillData.bedrooms) setValue('bedrooms', prefillData.bedrooms);
      if (prefillData.bathrooms) setValue('bathrooms', prefillData.bathrooms);
      if (prefillData.size) setValue('size', prefillData.size);
      if (prefillData.berRating) setValue('berRating', prefillData.berRating);

      if (prefillData.description) {
        setValue('description', prefillData.description);
      } else if (prefillData.notes) {
        setValue('description', prefillData.notes);
      }

      if (prefillData.amenities) setValue('amenities', prefillData.amenities);

      if (prefillData.images && prefillData.images.length > 0) {
        setPrefilledImages(prefillData.images);
        clearErrors('images');
      }

      setStep(1);
    }
  }, [location.state, setValue, setLocationInput, setStep, clearErrors, setPrefilledImages]);
};

export default useDraftLoading;
